exports = module.exports = require("../../../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._2PVg7Qe4u3wmEdV_d7YPog{}\n._3QuBOUMVamxWaGH3CeVLcN{\n    display: inline;\n    height: 35px;\n    vertical-align: top;\n    margin-top: 20px;\n}\n._3-ATMNt9G0EgmbqLOpgJ1t{\n    display: inline;\n    font-weight: bold;\n    font-size: 55px;\n    color: #F1F1F1;\n    margin-left: 10px;\n}", ""]);

// exports
exports.locals = {
	"container": "_2PVg7Qe4u3wmEdV_d7YPog",
	"icon": "_3QuBOUMVamxWaGH3CeVLcN",
	"text": "_3-ATMNt9G0EgmbqLOpgJ1t"
};